import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from './../../../auth/auth.service';
import { LoginService } from './../../../services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public form;
  public showLogin = true;
  redirectTo: string = '';

  constructor(
    private fb: FormBuilder,
    public auth: AuthService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _toastr: ToastrService,
    private _login: LoginService
  ) {
    this.form = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {
    this._route.queryParams
      .subscribe(params => this.redirectTo = params['redirectTo'] || '/catalogo');
  }

  login() {
    if (this.form.valid) {
      this._login.login(
        this.form.value.username,
        this.form.value.password,
        this._login.login2
      )
      // .subscribe(
      //   (response: any) => {
      //     if (response && response.Error) {
      //       this._toastr.error(response.Error);
      //       return false;
      //     } else if (response && response.User.FullName == 'WRONG_PASSWORD') {
      //       this._toastr.error('Usuário ou senha incorretos!')
      //       return false;
      //     }
      //     localStorage.clear();
      //     this._login.setUser(response);
  		// 		if (response.TIPO === "CLIENTE" && response.NFe) {
      //       window.location.href = 'http://institucionalteste/boleto';
  		// 		} else {
      //       this._router.navigateByUrl(this.redirectTo);
      //     }
      //   }
      // )
    } else {
      this._toastr.error('Preencha o login e senha para acessar!');
    }
  }

  toogleLoginForm() {
    this.showLogin = !this.showLogin;
  }
}